import { useEffect } from 'react';

/* This hook will take javascript URL as parameter and load the script after component will mount asynchronously. 
It will also remove the script on component unmount.*/

export const createScript = (url, isAsync = true) => {
  // Return if url is undefined or not passed
  if (!url) return '';

  const script = document.createElement('script');
  script.src = url;
  script.async = isAsync;
  document.body.appendChild(script);

  return script;
};

export const deleteScript = script => {
  script && document.body.removeChild(script);
};

const useScript = url => {
  useEffect(() => {
    const script = createScript(url);

    return () => {
      deleteScript(script);
    };
  }, [url]);
};

export default useScript;
